import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface NfseResumo {
    id: string
    emissao: string
    situacao: string
    /** CNPJ do prestador. */
    prestador: string
    /** Nome do prestador resolvido pelo CNPJ no backend (ausente se a consulta falhar). */
    prestadorRazaoSocial?: string | null
    prestadorNomeFantasia?: string | null
    tomador: string
    valorServico: number | null
    numeroNfse: string
    serie: string
}

export interface NfeResumo {
    id: string
    status: string
    emitente: string | null
    valorNfe: number | null
    numero: string
    serie: string
    chave: string
    dataEmissao: string | null
    pdf: string | null
    xml: string | null
}

export interface EmissoesParaMeuCNPJResposta {
    notasServico: NfseResumo[]
    notasMercadoria: NfeResumo[]
    mensagemServico?: string
    mensagemMercadoria?: string
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const buscarEmissoes = async function (
    authorization: string,
    dataInicial: string,
    dataFinal: string
): Promise<EmissoesParaMeuCNPJResposta | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<EmissoesParaMeuCNPJResposta>>(
                `notafiscal/EmissoesParaMeuCNPJ?dataInicial=${dataInicial}&dataFinal=${dataFinal}`,
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        const { data } = response
        if (data.codErro !== undefined && data.codErro > 0) {
            return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
        }
        return data as EmissoesParaMeuCNPJResposta
    } catch (error) {
        RegistrarLogErro(error, "buscarEmissoes", `${dataInicial}|${dataFinal}`)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const baixarArquivoNfse = async function (
    authorization: string,
    idNota: string
): Promise<Blob | ErroApi> {
    try {
        const response = await api.get(`notafiscal/BaixarPdfNfse/${idNota}`, {
            headers: { "Content-Type": "application/json", Authorization: authorization },
            responseType: "blob",
        })
        return response.data as Blob
    } catch (error) {
        RegistrarLogErro(error, "baixarArquivoNfse", idNota)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const baixarArquivoNfe = async function (
    authorization: string,
    url: string,
    tipo: "pdf" | "xml"
): Promise<Blob | ErroApi> {
    try {
        const response = await api.get(
            `notafiscal/BaixarArquivoNfe?url=${encodeURIComponent(url)}&tipo=${tipo}`,
            {
                headers: { "Content-Type": "application/json", Authorization: authorization },
                responseType: "blob",
            }
        )
        return response.data as Blob
    } catch (error) {
        RegistrarLogErro(error, "baixarArquivoNfe", `${url}|${tipo}`)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const baixarZipNotas = async function (
    authorization: string,
    dataInicial: string,
    dataFinal: string
): Promise<Blob | ErroApi> {
    try {
        const response = await api.get(
            `notafiscal/BaixarZipNfes?dataInicial=${dataInicial}&dataFinal=${dataFinal}`,
            {
                headers: { "Content-Type": "application/json", Authorization: authorization },
                responseType: "blob",
            }
        )
        return response.data as Blob
    } catch (error) {
        RegistrarLogErro(error, "baixarZipNotas", `${dataInicial}|${dataFinal}`)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
